import { createFileRoute, redirect } from '@tanstack/react-router'
import { parse } from 'valibot'

import { fetchShipmentOrderImportJobs } from '@/features/shipment-order-import-jobs/api'
import {
  selectedDcIdAtom,
  tenantStore
} from '@/routes/_protected/$tenantKey/-states'

import { shipmentOrderImportJobsSearchSchema } from './-models'

export const Route = createFileRoute(
  '/_protected/$tenantKey/shipment-order-import-jobs/'
)({
  validateSearch: (search) =>
    parse(shipmentOrderImportJobsSearchSchema, search),
  loaderDeps: ({ search }) => search,
  beforeLoad: ({ search, location }) => {
    const selectedDcId = tenantStore.get(selectedDcIdAtom)
    if (search.dcId != selectedDcId) {
      throw redirect({
        to: location.pathname,
        search: {
          ...search,
          dcId: selectedDcId
        }
      })
    }
  },
  loader: async ({ abortController, params: { tenantKey }, deps }) => {
    return {
      importJobs: await fetchShipmentOrderImportJobs(
        { tenantKey, query: deps },
        abortController.signal
      )
    }
  }
})
